/**
 * Footer - the dark bar at the bottom of every page.
 */

import { Link } from 'react-router-dom';

import { useI18n } from '../hooks/useI18n';
import { CheckCircle2 } from 'lucide-react';

import { useAuth } from '../hooks/useAuth';

const APP_NAME = import.meta.env.VITE_APP_NAME || 'ChoreConnect';

export default function Footer() {
  const { subscriptionsRequired, user } = useAuth();
  const { t } = useI18n();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <h4 className="row" style={{ gap: 8 }}>
              <CheckCircle2 size={20} aria-hidden="true" />
              {APP_NAME}
            </h4>
            <p className="text-sm" style={{ opacity: 0.85, maxWidth: '40ch' }}>
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <h4>{t('footer.forStudents')}</h4>
            <ul className="footer-links">
              <li>
                <Link to="/marketplace">{t('footer.browse')}</Link>
              </li>
              <li>
                <Link to="/signup/student">{t('footer.createAccount')}</Link>
              </li>
              <li>
              </li>
            </ul>
          </div>

          <div>
            <h4>{t('footer.forPosters')}</h4>
            <ul className="footer-links">
              <li>
                <Link to="/signup/user">{t('footer.createAccount')}</Link>
              </li>
              {subscriptionsRequired && (
                <li>
                  <Link to="/subscribe">{t('footer.membership')}</Link>
                </li>
              )}
              <li>
                <Link to="/chores/new">{t('footer.postChore')}</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>
            &copy; {new Date().getFullYear()} {APP_NAME} · <Link to="/privacy">{t('footer.privacy')}</Link> ·{' '}
            <Link to="/terms">{t('footer.terms')}</Link>
            {/* Only when signed in - it is a conversation tied to an account,
                and offering it to a signed-out visitor would lead to a login
                screen rather than to help. */}
            {user && (
              <>
                {' · '}
                <Link to="/report-issue">{t('footer.reportIssue')}</Link>
              </>
            )}
          </span>
          <span>
            {subscriptionsRequired
              ? t('footer.builtPaid')
              : t('footer.builtFree')}
          </span>
        </div>
      </div>
    </footer>
  );
}
